"use strict"

import React from "react"
import ReactNative from "react-native"
import Device from "app/lib/Device"
import { connect } from "react-redux"
import { colors } from "app/lib/styles"
import dataStore from "app/data/dataStore"
import * as Animatable from "react-native-animatable"

import LoadingOverlay from "app/components/LoadingOverlay"
import Guide from "app/views/MyChallenge/components/Guide"
import NewChallengeInviteFriends from "app/views/MyChallenge/components/NewChallengeInviteFriends"
import FS from "app/components/FS"

import {
  changeOnboardingStep,
  toggleGuide,
  toggleInviteFriends,
} from "app/actions/challenges"

const { StyleSheet, View, InteractionManager } = ReactNative

class ChallengeOnboarding extends FS.View {
  state = {
    changingSteps: false,
    readyForFullDisplay: false,
  }

  getMyUrl() {
    return "mychallenge/onboarding"
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.mounted = true
    InteractionManager.runAfterInteractions(() => {
      setTimeout(() => {
        if (this.mounted) {
          this.setState({ readyForFullDisplay: true })
        }
      }, 300)
    })
  }

  componentWillUnmount() {
    this.mounted = false
  }

  get sub() {
    var id = this.props.latestChallengeSubscriptionId
    if (id) {
      return dataStore.get("challenge_subscription", id)
    }
    return null
  }

  get index() {
    return this.props.onboardingStepIndex
  }

  get hasNextStep() {
    var done = false
    if (this.props.guideShowing) {
      done = true
    } else if (this.props.inviteFriendsShowing) {
      done = true
    } else if (this.index === 3) {
      done = true
    }
    return !done
  }

  finishUpNextPress = () => {
    if (this.hasNextStep) {
      var nextIndex = this.index + 1
      this.props.dispatch(changeOnboardingStep(nextIndex))
      this.setState({ changingSteps: false })
    } else if (this.props.guideShowing) {
      this.props.dispatch(toggleGuide())
    } else if (this.props.inviteFriendsShowing) {
      this.props.dispatch(toggleInviteFriends())
    } else {
      this.props.dispatch(changeOnboardingStep(null))
    }
  }

  handleNextPress = () => {
    if (!this.hasNextStep) {
      if (this._shadow) {
        this._shadow.fadeOut(200)
      }
      if (this._content) {
        this._content.bounceOutDown(300).then(this.finishUpNextPress)
      } else {
        this.finishUpNextPress()
      }
    } else {
      var _doneFn = () => {
        this.setState({ changingSteps: true }) //required to trigger slide in right animations effectively (removes element, then it gets added again after redux change)
        this.finishUpNextPress()
      }
      if (this._content) {
        this._content.fadeOut(50).then(_doneFn)
      } else {
        _doneFn()
      }
    }
  }

  renderHeader() {
    var headerLabel = ""
    if (!this.props.guideShowing && !this.props.inviteFriendsShowing) {
      if (this.index === 1) {
        headerLabel = "Read the guide to start"
      } else if (this.index === 2) {
        headerLabel = "Now add a buddy"
      } else {
        headerLabel = "All set!"
      }
    }
    return (
      <View style={styles.header}>
        <FS.Text style={styles.headerLabel}>{headerLabel}</FS.Text>
        <FS.Touchable onPress={this.handleNextPress} style={styles.headerButton}>
          <FS.Text style={styles.headerButtonText}>
            {this.hasNextStep ? "Next" : "Done"}
          </FS.Text>
        </FS.Touchable>
      </View>
    )
  }

  renderContents() {
    if (this.state.changingSteps) {
      return
    }

    if (this.index === 1) {
      return (
        <Animatable.View
          style={styles.dialog}
          animation="slideInUp"
          duration={200}
          ref={c => (this._content = c)}
        >
          {this.renderHeader()}
          <FS.ScrollView
            style={styles.content}
            contentContainerStyle={styles.contentContainer}
          >
            <Guide
              challenge={this.sub.challenge}
              isInModal={true}
              style={styles.guide}
              navigation={this.props.navigation}
            />
          </FS.ScrollView>
        </Animatable.View>
      )
    } else if (this.index === 2) {
      var animation = this.props.inviteFriendsShowing ? "slideInUp" : "slideInRight"
      return (
        <Animatable.View
          style={styles.dialog}
          animation={animation}
          duration={200}
          ref={c => (this._content = c)}
        >
          {this.renderHeader()}
          <FS.ScrollView
            style={styles.content}
            contentContainerStyle={styles.contentContainer}
          >
            <NewChallengeInviteFriends />
          </FS.ScrollView>
        </Animatable.View>
      )
    } else if (this.index === 3) {
      var animation = "slideInRight"
      return (
        <Animatable.View
          style={styles.dialog}
          animation={animation}
          duration={200}
          ref={c => (this._content = c)}
        >
          {this.renderHeader()}
          <FS.ScrollView
            style={styles.content}
            contentContainerStyle={styles.contentContainer}
          >
            <View style={styles.nextUpWrap}>
              <FS.Text style={styles.nextUpText}>
                Don't forget to check in next time you eat or drink
              </FS.Text>
              <FS.Image
                source={{
                  uri:
                    "http://foodstand.imgix.net/assets/images/challengeOnboardingCheckinIntro.png",
                }}
                style={styles.nextUpImage}
              />
            </View>
          </FS.ScrollView>
        </Animatable.View>
      )
    }
  }

  render() {
    if (this.index === null || !this.sub || !this.state.readyForFullDisplay) {
      return <View />
    }

    return (
      <View style={styles.container}>
        <Animatable.View
          style={styles.shadow}
          animation="fadeIn"
          duration={200}
          ref={c => (this._shadow = c)}
        >
          <FS.Touchable style={styles.shadowButton} onPress={this.handleNextPress} />
        </Animatable.View>
        {this.renderContents()}
      </View>
    )
  }
}

function mapStateToProps(state) {
  return Object.assign({}, state.challenges)
}

export default connect(mapStateToProps)(ChallengeOnboarding)

var styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    justifyContent: "flex-end",
  },
  shadow: {
    flex: 1,
    position: "absolute",
    top: -20,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  shadowButton: {
    flex: 1,
    position: "absolute",
    top: -20,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "transparent",
  },
  dialog: {
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
  },
  content: {
    height: Device.height - 180,
    flexGrow: 1,
    backgroundColor: colors.white,
  },
  contentContainer: {
    flex: 1,
    backgroundColor: colors.veryLightGray,
  },
  header: {
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    backgroundColor: colors.white,
    padding: 5,
    justifyContent: "center",
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: colors.lightMediumGray,
  },
  headerLabel: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    textAlign: "left",
    fontSize: 16,
    fontWeight: "800",
    color: colors.darkGray,
    flex: 1,
  },
  headerButton: {
    paddingHorizontal: 12,
    paddingLeft: 20,
    paddingVertical: 8,
  },
  headerButtonText: {
    color: colors.challengeOrange,
    fontSize: 16,
    fontWeight: "800",
    textAlign: "right",
  },
  guide: {
    flex: 1,
    height: 200,
  },
  nextUpWrap: {
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 30,
  },
  nextUpImage: {
    width: 300,
    height: 146,
    transform: [{ scale: 0.9 }],
  },
  nextUpText: {
    fontSize: 16,
    fontWeight: "800",
    color: colors.darkGray,
    textAlign: "center",
    width: 280,
  },
})
